/**
 * Storyella 品牌 - Member 页面配置
 */
import novelarcVipIcon from '../icons/novelarc/vip.png'
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

/**
 * Storyella 品牌特定主题配置
 */
export const theme = {
  // 头像边框色
  avatarBorder: '#FFF0F3',
  // 按钮背景色
  btnPrimaryBg: '#FFF0F3',
  // Top Up 按钮背景色
  topUpBtnBg: 'linear-gradient(90deg, #FF6734 0.03%, #FF42CC 100%)',
  // VIP 背景图 URL
  vipSubscribeBg: 'url(/images/storyella/member_subscribe_bg.webp)',
} as const

/**
 * Storyella 品牌特定资源配置
 */
export const resources = {
  // 页面背景图
  memberBg: '/images/storyella/member-bg.webp',
  // 用户背景图
  userBg: '/images/storyella/user-bg.webp',
  // 用户默认头像
  userDefaultAvatar: '/images/storyella/user-default.png',
  // VIP 图标
  memberVip: novelarcVipIcon,
  // VIP 折扣图标
  memberVipDiscount: '/images/storyella/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
}
